import { getWorkedStatusConfig } from "../../../config/workstatus.config";
import { WorkedStatus } from "../enums/workedStatus.enum";
import { Box, Chip } from "@mui/material";
import { AlertColor } from "@mui/material";

export const StatusBadge = ({ status }: { status: WorkedStatus }) => {
  const config = getWorkedStatusConfig(status);

  return (
    <Chip
      label={config.label}
      sx={{
        bgcolor: config.bg,
        color: config.text,
        border: `1px solid ${config.border}`,
        width: 80,
        height: 20,
        fontWeight: 800,
        fontSize: 9,
        borderRadius: "6px",
        textTransform: "uppercase",
        "& .MuiChip-label": {
          px: 1,
        },
      }}
    />
  );
};

export const AlertDot = ({ color }: { color: AlertColor | "info" }) => {
  const palette = {
    success: "#22c55e",
    warning: "#f59e0b",
    error: "#ef4444",
    info: "#3b82f6",
  };

  const selectedColor = palette[color as keyof typeof palette] || palette.success;

  return (
    <Box
      sx={{
        width: 8,
        height: 8,
        borderRadius: "50%",
        bgcolor: selectedColor,

        boxShadow: `0 0 0 3px ${selectedColor}22`,
        flexShrink: 0,
      }}
    />
  );
};
